
import { FormElementController, FormPageValidator, FormElementValidator, StringValidators, ValidationResult, FormElementStatus } from './../../../scripts/formcontrols'
import moment from 'moment'
export default class ManualFmdEntryController extends FormPageValidator {

    public gtin     : FormElementController<string>;
    public sn       : FormElementController<string>;
    public batch    : FormElementController<string>;
    public expiry   : FormElementController<string>;

    constructor() {
        super()

        var gtinvalidator = new FormElementValidator(true, (v: string) => {
            if (v.length != 14) {
                return new ValidationResult(FormElementStatus.Error, "Please enter a valid 14 digit GTIN")
            }

            if (isNaN(parseFloat(v))) {
                return new ValidationResult(FormElementStatus.Error, "Please enter a correct GTIN numeric value")
            }
            return new ValidationResult(FormElementStatus.Success, "");
        });
        var snvalidator = new FormElementValidator(true, (v: string) => {
            if (v.length > 20) {
                return new ValidationResult(FormElementStatus.Error, "Serial cannot be more than 20 alpha-numeric charectors")
            }
            if (!v.match("^[A-z0-9]+$")) {
                return new ValidationResult(FormElementStatus.Error, "Serial can only contain alpha-numeric charectors")
            }
            return new ValidationResult(FormElementStatus.Success, "");
        });

        //var batchvalidator = new FormElementValidator(false, (v: string) => {
        //    if (v.length!=0 && !v.match("^[A-z0-9]+$")) {
        //        return new ValidationResult(FormElementStatus.Error, "Batch can only contain alpha-numeric charectors")
        //    }
        //    return new ValidationResult(FormElementStatus.Success, "");
        //});
        var batchvalidator = new FormElementValidator(false);


        var expiryvalidator = new FormElementValidator(false, (v: string) => {
            if (v == "") {
                return new ValidationResult(FormElementStatus.Success, "");
            }

            if (!(v.length == 4 || v.length == 6)) {
                return new ValidationResult(FormElementStatus.Error, "Enter Date in YYMM or YYMMDD Format")
            }

            var dateStr = v;

            if (v.length == 4) {
                dateStr += "01";
            }

            if (!moment(dateStr, "YYMMDD").isValid()) {
                return new ValidationResult(FormElementStatus.Error, "Please enter a correct date in YYMM or YYMMDD format")
            }
            return new ValidationResult(FormElementStatus.Success, "");
        });


        this.gtin = new FormElementController<string>("GTIN  ", "", gtinvalidator);


        this.sn     = new FormElementController<string>("Serial  ", "", snvalidator     );
        this.batch  = new FormElementController<string>("Batch", "", batchvalidator  );
        this.expiry = new FormElementController<string>("Expiry", "", expiryvalidator );

        this.expiry.placeholder = "YYMMDD"

        this.addValidators(
            gtinvalidator  
            ,snvalidator    
            ,batchvalidator 
            ,expiryvalidator
        );
    }
}


// WEBPACK FOOTER //
// ./ClientApp/components/FmdControls/BagManagement/ManualFmdEntryController.ts